import { env } from 'config/env';
import config from 'config/constants';
import { isEnvironmentInApiKey } from 'app/utils';

// Init-only snippets for each SDK. Mirrors the option-encoding rules in
// pages/Dashboard/utils/codeExamples.ts — when the API key already encodes
// the environment we omit the `environment` option, otherwise we surface it
// so devs see the exact options they need to pass.

const fallback = (apiKey: string) => apiKey || 'YOUR_API_KEY';

export const createTypescriptInitSnippet = (apiKey = '') => {
  const optionsBody = isEnvironmentInApiKey(apiKey)
    ? `  apiKey: "${fallback(apiKey)}",`
    : `  apiKey: "${fallback(apiKey)}",
  environment: "${env.VITE_NODE_ENV}",`;

  return `import CheckoutIntents from 'checkout-intents';

const client = new CheckoutIntents({
${optionsBody}
});`;
};

export const createPythonInitSnippet = (apiKey = '') => {
  const optionsBody = isEnvironmentInApiKey(apiKey)
    ? `    api_key="${fallback(apiKey)}",`
    : `    api_key="${fallback(apiKey)}",
    environment="${env.VITE_NODE_ENV}",`;

  return `from checkout_intents import CheckoutIntents

client = CheckoutIntents(
${optionsBody}
)`;
};

export const createJavaInitSnippet = (apiKey = '') => {
  const optionsBody = isEnvironmentInApiKey(apiKey)
    ? `    .apiKey("${fallback(apiKey)}")`
    : `    .apiKey("${fallback(apiKey)}")
    .environment("${env.VITE_NODE_ENV}")`;

  return `import com.rye.client.okhttp.CheckoutIntentsOkHttpClient

val client =
  CheckoutIntentsOkHttpClient.builder()
${optionsBody}
    .build()`;
};

export const createRubyInitSnippet = (apiKey = '') => {
  const optionsBody = isEnvironmentInApiKey(apiKey)
    ? `  api_key: "${fallback(apiKey)}"`
    : `  api_key: "${fallback(apiKey)}",
  environment: "${env.VITE_NODE_ENV}"`;

  return `require "checkout_intents"

client = CheckoutIntents::Client.new(
${optionsBody}
)`;
};

// cURL doesn't have an "init" — the closest analogue is showing the
// authorization header devs need on every request.
export const createCurlInitSnippet = (apiKey = '') =>
  `curl --request GET \\
  --url ${config.external.checkoutIntent} \\
  --header "Authorization: Bearer ${fallback(apiKey)}"`;
